import PermissionContext  from './permission-context'
import {useState,useEffect} from 'react'

const PremissionProvider =(props:any)=>{
 
    const [newPermission,setNewPermission]=useState(false)
   
   

    return (
        <PermissionContext.Provider
        value={
            {
               
         newPermission,
         setNewPermission
        }
        }>
            {props.children}
        </PermissionContext.Provider>
    )
}
export default PremissionProvider;